import React, { Component } from 'react';
import 'rc-collapse/assets/index.css';
import Collapse, { Panel } from 'rc-collapse';


export default class OrganizationBlock extends Component {

  getItems() {
    let items = [];
    let that = this;
    Object.keys(this.props.organizationData).forEach(org => {
      let participants = [];
      that.props.organizationData[org].forEach(participant => {
        if (that.props.filter === undefined || participant.sections.indexOf(parseInt(that.props.filter, 10)) !== -1) {
          participants.push(
            <div key={participant.idStr} className='participant'>
              <div className='participant__name'>
                {`${participant.lastName} ${participant.firstName}`}
              </div>
              <div className='participant__about'>
                {participant.education}
              </div>
            </div>
          );
        }
      });
      if (participants.length !== 0) {
        items.push(
          <Panel key={`${org}-${that.props.filter}`} header={`${org} (${participants.length})`}>
            {participants}
          </Panel>
        );
      }
    });

    return items;
  }

  render() {
    return (
      <Collapse
        accordion={false}
        key={this.props.keyData}
      >
        {this.getItems()}
      </Collapse>
    );
  }
}



// WEBPACK FOOTER //
// ./src/participants-page/blocks/OrganizationBlock.js